import React from 'react';
import { Field } from 'react-final-form';
import cx from 'classnames';
import PropTypes from 'prop-types';

import Condition from '../../../../../../../components/Condition';
import DateField from '../../../../../../../components/DateField';
import HelpfulInfoCard from '../../../../../../../components/HelpfulInfo';
import RadioGroup from '../../../../../../../components/RadioGroup';
import WaterThickIcon from '../../../../../../../icons/WaterThick';
import composeValidators from '../../../../../../../validators/composeValidators';
import conditionalValidation from '../../../../../../../validators/conditionalValidation';
import fieldRequiredStandard from '../../../../../../../validators/fieldRequired';
import isDate from '../../../../../../../validators/isDate';
import SectionTitle from '../../../../../common/SectionTitle';
import { useStandaloneWizardState } from '../../../../../standalone-wizard/StandaloneWizardProvider';

import styles from './SprinklerDisclosure.module.scss';

const SprinklerDisclosure = ({ className }) => {
  const { standAloneWizard } = useStandaloneWizardState();
  const fieldRequired = conditionalValidation(
    fieldRequiredStandard,
    !standAloneWizard,
  );

  return (
    <>
      <div className={cx(styles.container, className)}>
        <HelpfulInfoCard noIcon noTitle className={styles.helpfulInfo}>
          Pursuant to GCS 47a-3F, Landlords shall include notice in the Lease of
          any operative fire system
        </HelpfulInfoCard>
        <SectionTitle title="Sprinkler Disclosure" icon={WaterThickIcon} />
        <label className={styles.label}>
          Is there an operative Fire Sprinkler System on the Leased Premises?
        </label>
        <p className={styles.description}>
          Landlords are required to provide notice of the existence of an
          operable fire sprinkler system located on the property and the last
          date of maintenance and inspection.
        </p>

        <Field
          component={RadioGroup}
          id="custom_state_data.is_there_fire_sprinkler_system"
          name="custom_state_data.is_there_fire_sprinkler_system"
          radiosContainerClassName={styles.radioButtonsContainer}
          options={[
            {
              id: 'is_there_fire_sprinkler_system_yes',
              value: true,
              label: 'Yes',
            },
            {
              id: 'is_there_fire_sprinkler_system_no',
              value: false,
              label: 'No',
            },
          ]}
          validate={fieldRequired}
        />
        <Condition
          when="custom_state_data.is_there_fire_sprinkler_system"
          is={true}
        >
          <Field
            className={styles.date}
            label=" Date of last maintenance and inspection:"
            component={DateField}
            name="custom_state_data.fire_sprinkler_system_last_maintenance_date"
            id="custom_state_data.fire_sprinkler_system_last_maintenance_date"
            validate={composeValidators(fieldRequired, isDate)}
          />
        </Condition>
      </div>
    </>
  );
};

SprinklerDisclosure.propTypes = {
  className: PropTypes.string,
};

export default SprinklerDisclosure;
